export const BILLING_PRICES = {
  usd: { symbol: "$", monthly: 14, yearly: 140 },
  eur: { symbol: "€", monthly: 12, yearly: 120 },
  dzd: { symbol: "DZD", monthly: 1900, yearly: 19000 },
  kwd: { symbol: "KD", monthly: 4, yearly: 40 },
  sar: { symbol: "SAR", monthly: 49, yearly: 490 },
};